import Vue from 'vue'
import Vuex from 'vuex'
import Chat from './chat'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  Chat: Chat,
  }
})
